import { useEffect, useState } from "react";
import { Form } from "antd";
import InterventionsTable from "./InterventionsTable";

export const InterventionForm = ({ quarter, quarters, writeFn, mapInterventionFn, RecordList, ...props }) => {
  const [active, setActive] = useState(undefined)
  const [quarterStartDate, setQuarterStartDate] = useState(undefined)
  const [quarterEndDate, setQuarterEndDate] = useState(undefined)
  const [initialData, setInitialData] = useState([])
  const [loading, setLoading] = useState(true)
  const [form] = Form.useForm();

  const { query: { getQuery, iterator, root } } = props;

  useEffect(() => {
    (async () => {
      setLoading(true)
      const quarterNode = await new Weaver.Query().restrict(quarter).first()
      setQuarterStartDate(quarterNode.get('http://pms.coentunnelcompany.nl/rdl#startDate'))
      setQuarterEndDate(quarterNode.get('http://pms.coentunnelcompany.nl/rdl#endDate'))
      const rows = await new Weaver.Sparql(getQuery(quarter)).iterator(iterator , root).all()
      const fieldData = _.flatten(rows.map((row) => row.intervention?.map(mapInterventionFn)))
      setInitialData(fieldData)
      form.setFieldsValue({ interventions: fieldData || {} })
      setLoading(false)
    })()
  }, [quarter])

  const onFinish = async ({ interventions }) => {
    try {
      if(writeFn === null) {
        return;
      }
      const data = interventions[active];
      const existingData = initialData[active];
      const { newData, writes } = await writeFn(existingData, data)
      await Weaver.Functions.executeWrites(writes);
      const newFormData = initialData
      newFormData[active] = newData
      form.setFieldsValue({ interventions: newFormData })
      setInitialData(newFormData)
      setActive(undefined)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Form
      form={form}
      name={props.name}
      onFinish={onFinish}
    >
      <Form.List name="interventions">
        {(interventions, { add, remove }) => (
          <InterventionsTable
            quarter={quarter}
            quarterStartDate={quarterStartDate}
            quarterEndDate={quarterEndDate}
            quarters={quarters}
            form={form}
            dataSource={interventions}
            add={writeFn?add:null}
            remove={writeFn?remove:null}
            setActive={setActive}
            active={active}
            loading={loading}
            RecordList={RecordList}
            { ...props }
          />
        )}
      </Form.List>
    </Form>
  );
};
